import gatewayServer from "./gatewayServer"
import server from "./server"

const userManagementBaseUrl = gatewayServer.gatewayBaseUrl + "/usermanagement"
const services = {
    "user.creation": "/user/create",
    "user.deletion": "/user/delete",
    "profile": "/profile/autocomplete",
    "find-r2-profile": "/profile/find/R2",
    "permission-group": "/permission-group/",
    "permission-group-inactivate":"permission-group/inactivate",
    "permission-group-presentation-tree": "/permission-group/presentation-tree",
    "permission-group-export": "/permission-group/presentation-tree/export",
    "permission-group-company":"/permission-group-company/",
    "permission-group.find": "/permission-group/find",
    "permission-group.findById":"permission-group/find-by-id",
    "permission-group-get-info":"/permission-group/get-info",
    "permission-group-company-unities-users":"/permission-group-company/company-unities-users",
    "permission-group-unities-users":"/permission-group-company/unities-users",
    "permission-group-authenticated":"permission-group/authenticated",
    "exportScriptId": "/transactional/report/query/findBySourceId",
    "admin-user-creator":"/r2-default-admin-user-creator/regional-admins",
    "purge":"database/purge",
}

export const userManagementServer = {
    getBaseUrl() {
        return userManagementBaseUrl
    },
    getServiceUrl(service: keyof typeof services) {
        const relativeUrl = services[service]
        if (!relativeUrl) {
            return relativeUrl
        }
        return server.concatPaths(this.getBaseUrl(), relativeUrl)
    }
}

export default userManagementServer